// German translations
export const de = {
  // ============================================================================
  // Common / Shared
  // ============================================================================
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    create: 'Erstellen',
    update: 'Aktualisieren',
    search: 'Suchen',
    filter: 'Filtern',
    export: 'Exportieren',
    import: 'Importieren',
    refresh: 'Aktualisieren',
    loading: 'Wird geladen...',
    error: 'Fehler',
    success: 'Erfolg',
    confirm: 'Bestätigen',
    close: 'Schließen',
    yes: 'Ja',
    no: 'Nein',
    ok: 'OK',
    back: 'Zurück',
    next: 'Weiter',
    previous: 'Zurück',
    submit: 'Absenden',
    reset: 'Zurücksetzen',
    clear: 'Leeren',
    apply: 'Anwenden',
    add: 'Hinzufügen',
    remove: 'Entfernen',
    view: 'Ansehen',
    viewAll: 'Alle ansehen',
    viewDetails: 'Details ansehen',
    showing: 'Zeige',
    of: 'von',
    items: 'Einträge',
    noData: 'Keine Daten verfügbar',
    noResults: 'Keine Ergebnisse gefunden',
    retry: 'Erneut versuchen',
    status: 'Status',
    actions: 'Aktionen',
    name: 'Name',
    description: 'Beschreibung',
    date: 'Datum',
    time: 'Zeit',
    today: 'Heute',
    yesterday: 'Gestern',
    ago: 'vor',
    never: 'Nie',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    all: 'Alle',
    none: 'Keine',
    select: 'Auswählen',
    selectAll: 'Alle auswählen',
    required: 'Erforderlich',
    optional: 'Optional',
    default: 'Standard',
  },

  // ============================================================================
  // General UI
  // ============================================================================
  general: {
    comingSoon: 'Demnächst verfügbar',
    comingSoonDescription: 'Diese Funktion wird in einem zukünftigen Update verfügbar sein.',
    more: 'Mehr',
    noDataAvailable: 'Keine Daten verfügbar',
    tryAgain: 'Erneut versuchen',
    somethingWentWrong: 'Etwas ist schiefgelaufen',
    unexpectedError: 'Auf dieser Seite ist ein unerwarteter Fehler aufgetreten.',
    resourceGone: 'Ressource nicht mehr verfügbar',
    resourceGoneDescription: 'Diese Ressource wurde dauerhaft entfernt.',
    searchProducts: 'Produkte suchen',
    dashboard: 'Dashboard',
  },

  // ============================================================================
  // Navigation / Sidebar
  // ============================================================================
  nav: {
    dashboard: 'Dashboard',
    workflow: 'Workflow',
    analysis: 'Analyse',
    discovery: 'Produktsuche',
    contentDiscovery: 'Inhaltssuche',
    sellers: 'Händlerübersicht',
    pricing: 'Meine Preise',
    matching: 'Matching',
    aiAdvisor: 'AI Advisor',
    settings: 'Einstellungen',
    roadmap: 'Roadmap',
    logout: 'Abmelden',
    profile: 'Profil',
    schedules: 'Zeitpläne',
    billing: 'Abrechnung',
    groupOverview: 'Übersicht',
    groupData: 'Daten',
    groupExecution: 'Ausführung',
    groupTools: 'Tools & Einstellungen',
  },

  // ============================================================================
  // Authentication
  // ============================================================================
  auth: {
    login: 'Anmelden',
    logout: 'Abmelden',
    register: 'Registrieren',
    signIn: 'Einloggen',
    signUp: 'Registrieren',
    signOut: 'Ausloggen',
    welcomeBack: 'Willkommen zurück',
    createAccount: 'Konto erstellen',
    forgotPassword: 'Passwort vergessen?',
    resetPassword: 'Passwort zurücksetzen',
    rememberMe: 'Angemeldet bleiben',
    username: 'Benutzername',
    email: 'E-Mail',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    apiKey: 'API-Schlüssel',
    enterCredentials: 'Geben Sie Ihren Benutzernamen und Ihr Passwort ein',
    enterApiKey: 'Geben Sie Ihren API-Schlüssel ein',
    invalidCredentials: 'Ungültige Anmeldedaten',
    loginFailed: 'Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Daten.',
    loginSuccess: 'Erfolgreich angemeldet',
    logoutSuccess: 'Erfolgreich abgemeldet',
    sessionExpired: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
    // 2FA
    twoFactor: 'Zwei-Faktor-Authentifizierung',
    enterCode: 'Bitte geben Sie den Code aus Ihrer Authenticator-App ein',
    invalidCode: 'Ungültiger 2FA-Code',
    // Register
    alreadyHaveAccount: 'Bereits ein Konto?',
    dontHaveAccount: 'Noch kein Konto?',
    agreeToTerms: 'Ich stimme den Nutzungsbedingungen und der Datenschutzerklärung zu',
    registrationSuccess: 'Konto erfolgreich erstellt',
    passwordRequirements: 'Passwort muss mindestens 8 Zeichen lang sein',
  },

  // ============================================================================
  // Login Page
  // ============================================================================
  login: {
    welcomeBack: 'Willkommen zurück',
    twoFactorAuth: 'Zwei-Faktor-Authentifizierung',
    signInDescription: 'Geben Sie Ihren Benutzernamen und Ihr Passwort ein, um sich anzumelden',
    apiKeyDescription: 'Geben Sie Ihren API-Schlüssel ein, um sich anzumelden',
    authenticatorDescription: 'Bitte geben Sie den Code aus Ihrer Authenticator-App ein',
    passwordButton: 'Passwort',
    apiKeyButton: 'API-Schlüssel',
    usernameLabel: 'Benutzername oder E-Mail',
    usernamePlaceholder: 'benutzername oder email@beispiel.de',
    passwordLabel: 'Passwort',
    forgotPassword: 'Passwort vergessen?',
    apiKeyLabel: 'API-Schlüssel',
    apiKeyPlaceholder: 'c-FZnIdq...',
    apiKeyHelp: 'Ihren API-Schlüssel finden Sie in Ihren Profileinstellungen',
    signingIn: 'Anmeldung...',
    signIn: 'Anmelden',
    authCodeLabel: 'Authentifizierungscode',
    authCodePlaceholder: '000 000',
    verifying: 'Überprüfung...',
    verifyCode: 'Code überprüfen',
    backToLogin: 'Zurück zur Anmeldung',
    resetPassword: 'Passwort zurücksetzen',
    resetPasswordDescription: 'Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen ein neues Passwort.',
    emailLabel: 'E-Mail-Adresse',
    emailPlaceholder: 'ihre@email.de',
    cancel: 'Abbrechen',
    sending: 'Senden...',
    sendResetEmail: 'E-Mail senden',
    passwordResetSent: 'E-Mail zum Zurücksetzen des Passworts gesendet! Bitte überprüfen Sie Ihren Posteingang.',
  },

  // ============================================================================
  // Dashboard
  // ============================================================================
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Echtzeit-Marktübersicht und Leistungskennzahlen.',
    loading: 'Dashboard wird geladen...',
    errorLoading: 'Dashboard-Daten konnten nicht geladen werden',
    allJobs: 'Alle Jobs',
    // KPIs
    totalProjects: 'Projekte',
    totalTasks: 'Aufgaben',
    totalJobs: 'Jobs',
    productsExtracted: 'Extrahiert',
    productsNormalized: 'Normalisiert',
    productsMatched: 'Gematcht',
    activeProducts: 'Aktive Produkte',
    avgMarketPrice: 'Ø Marktpreis',
    competitorsMonitored: 'Wettbewerber',
    totalOffers: 'Angebote Gesamt',
    totalRevenue: 'Gesamtumsatz',
    platformCoverage: 'Plattformabdeckung',
    // Charts
    domainCoverage: 'Domain-Abdeckung',
    domainCoverageTooltip: 'Zeigt wie viele Produkte pro Referenz-Domain überwacht werden. Nutzen Sie das Dropdown um zwischen Produktanzahl und Angebotsanzahl zu wechseln.',
    jobStatusDistribution: 'Job-Status Verteilung',
    jobStatusTooltip: 'Visuelle Aufschlüsselung aller Jobs nach ihrem aktuellen Status. Der Prozentsatz zeigt die Abschlussrate.',
    jobStatusDescription: 'Übersicht der Job-Abschlussrate',
    rrpDeviation: 'UVP-Abweichung',
    // Job Status
    recentJobs: 'Letzte Jobs',
    recentJobsDescription: 'Letzte Crawl-Job Aktivitäten',
    recentJobsTooltip: 'Zeigt die 5 neuesten Jobs über alle Projekte. Klicken Sie auf "Alle anzeigen" um den vollständigen Workflow mit allen Projekten, Aufgaben und Jobs zu sehen.',
    jobStatus: 'Job-Status',
    jobStatusSummaryTooltip: 'Zusammenfassung aller Jobs gruppiert nach Status: Ausstehend (warten auf Ausführung), Läuft (wird ausgeführt), Abgeschlossen (erfolgreich beendet), Fehlgeschlagen (Fehler aufgetreten).',
    noJobs: 'Noch keine Jobs',
    noDomains: 'Keine Domains konfiguriert',
    // Status
    pending: 'Ausstehend',
    running: 'Läuft',
    completed: 'Abgeschlossen',
    failed: 'Fehlgeschlagen',
    // Competitors
    topCompetitors: 'Top Wettbewerber',
    topDomains: 'Top Domains',
    topDomainsDescription: 'Nach Referenz-URL Abdeckung',
    topDomainsTooltip: 'Zeigt Domains mit der höchsten Produktüberschneidung. Sortiment zeigt gematchte/Gesamt-Produkte, Preisabw. zeigt die durchschnittliche Preisabweichung zu Ihren Preisen.',
    competitor: 'Wettbewerber',
    domain: 'Domain',
    assortment: 'Sortiment',
    priceDev: 'Preisabw.',
    viewMatrix: 'Matrix ansehen',
    // System
    systemActive: 'System Aktiv',
    systemStable: 'System Stabil',
    lastCrawl: 'Letzter Crawl',
  },

  // ============================================================================
  // Workflow
  // ============================================================================
  workflow: {
    title: 'Workflow',
    subtitle: 'Verwalten Sie Ihre Scraping-Projekte, Aufgaben und Jobs.',
    // Projects
    projects: 'Projekte',
    project: 'Projekt',
    newProject: 'Neues Projekt',
    editProject: 'Projekt bearbeiten',
    deleteProject: 'Projekt löschen',
    projectName: 'Projektname',
    projectDescription: 'Projektbeschreibung',
    noProjects: 'Noch keine Projekte',
    createFirstProject: 'Erstellen Sie Ihr erstes Projekt, um loszulegen.',
    // Tasks
    tasks: 'Aufgaben',
    task: 'Aufgabe',
    newTask: 'Neue Aufgabe',
    editTask: 'Aufgabe bearbeiten',
    deleteTask: 'Aufgabe löschen',
    taskName: 'Aufgabenname',
    taskDescription: 'Aufgabenbeschreibung',
    noTasks: 'Keine Aufgaben',
    selectProject: 'Wählen Sie ein Projekt, um Aufgaben anzuzeigen.',
    // Jobs
    jobs: 'Jobs',
    job: 'Job',
    newJob: 'Neuer Job',
    editJob: 'Job bearbeiten',
    deleteJob: 'Job löschen',
    executeJob: 'Job ausführen',
    stopJob: 'Job stoppen',
    jobType: 'Job-Typ',
    jobConfig: 'Job-Konfiguration',
    noJobs: 'Keine Jobs',
    selectTask: 'Wählen Sie eine Aufgabe, um Jobs anzuzeigen.',
    // URLs
    urls: 'URLs',
    masterUrl: 'Master-URL',
    masterUrlLocked: 'Die Master-URL ist nach Erstellung von Jobs gesperrt. Erstellen Sie eine neue Aufgabe für eine andere Master-URL.',
    structuralChangeWarning: 'Änderungen an Plattformen oder URLs bei bestehenden Daten können alte Ergebnisse verwaisen lassen.',
    referenceUrls: 'Referenz-URLs',
    addUrl: 'URL hinzufügen',
    // CSV-Modus
    csvMode: {
      urlCount: 'URLs',
      discoveryLabel: 'Auto-Erkennung',
      crawlLimitCsv: 'Max. URLs aus hochgeladener Liste ({{total}} gesamt)',
      crawlLimitHint: 'Crawl-Limit gilt für hochgeladene URLs. {{total}} URLs hochgeladen.',
    },
    // Status
    jobPending: 'Ausstehend',
    jobRunning: 'Wird ausgeführt',
    jobCompleted: 'Abgeschlossen',
    jobFailed: 'Fehlgeschlagen',
    // Actions
    runPipeline: 'Pipeline starten',
    viewResults: 'Ergebnisse anzeigen',
    viewSelectors: 'Selektoren anzeigen',
    // Confirmations
    confirmDeleteProject: 'Sind Sie sicher, dass Sie dieses Projekt löschen möchten? Alle Aufgaben und Jobs werden gelöscht.',
    confirmDeleteTask: 'Sind Sie sicher, dass Sie diese Aufgabe löschen möchten? Alle Jobs werden gelöscht.',
    confirmDeleteJob: 'Sind Sie sicher, dass Sie diesen Job löschen möchten?',
  },

  // ============================================================================
  // Price Analysis
  // ============================================================================
  analysis: {
    // Analysis page tabs
    tabPrices: 'Preisvergleich',
    tabWebsiteInfo: 'Website Info',
    // Website Info tab
    websiteInfoTitle: 'Website-Informationen',
    websiteInfoDescription: 'Daten aus sekundären Modulen während des Crawls extrahiert (Firmendaten, Versand, Retouren, FAQs, etc.).',
    noModuleResults: 'Noch keine Modul-Daten',
    noModuleResultsHint: 'Sekundäre Module extrahieren Infos wie Firmendaten, Versandrichtlinien und FAQs beim nächsten Crawl.',
    modulePagesAnalyzed: '{count} Seite(n) analysiert',
    moduleSourceUrls: 'Quell-URLs',
    // Secondary modules states
    secondaryNotEnabled: 'Sekundäre Module nicht aktiviert',
    secondaryNotEnabledHint: 'Aktivieren Sie sekundäre Extraktionsmodule in Ihren Aufgabeneinstellungen, um Firmendaten, Versandinfos, FAQs und mehr von Wettbewerber-Websites zu sammeln.',
    modulesNotTriggered: 'Module nicht ausgelöst',
    modulesNotTriggeredHint: 'Diese Module waren aktiviert, aber es wurden keine passenden Seiten während des Crawls gefunden. Sie werden möglicherweise in zukünftigen Crawls ausgeführt.',
    // Status labels
    statusCompleted: 'Abgeschlossen',
    statusFailed: 'Fehlgeschlagen',
    statusPending: 'Ausstehend',
    extractionFailed: 'Extraktion fehlgeschlagen',
    noDataExtracted: 'Noch keine Daten extrahiert',
    unknownDomain: 'Unbekannte Domain',
    title: 'Preisanalyse',
    subtitle: 'Überwachen Sie Wettbewerbspreise und Lagerbestände in Echtzeit.',
    newFilter: 'Neuer Filter',
    quickFilters: 'Schnellfilter',
    // PriceAnalysis component
    priceAnalysisTitle: 'Preisanalyse',
    priceAnalysisSubtitle: 'Analysieren und vergleichen Sie Produktpreise über verschiedene Quellen.',
    selectJob: 'Wählen Sie einen Job zur Analyse',
    noJobSelected: 'Kein Job ausgewählt',
    selectJobHint: 'Wählen Sie oben ein Projekt, eine Aufgabe und einen Job aus, um die Preisanalyse anzuzeigen.',
    matchConfig: 'Match-Konfiguration',
    activeConfig: 'Aktive Konfiguration',
    createConfig: 'Konfiguration erstellen',
    editConfig: 'Bearbeiten',
    setActive: 'Aktivieren',
    deleteConfig: 'Löschen',
    runMatching: 'Matching starten',
    catalogModeActive: 'Katalog-Modus',
    catalogModeDescription: 'Das Matching wird für Katalog-Jobs automatisch durchgeführt. Um Masterpreise zu aktualisieren, laden Sie eine CSV mit den Spalten "ean" und "price" hoch (optional: "currency").',
    updatePrices: 'Preise aktualisieren',
    pricesUpdated: '{{count}} Preise erfolgreich aktualisiert.',
    pricesNotFound: '{{count}} EANs nicht gefunden',
    uploadPricesCsvHint: 'CSV mit "ean"- und "price"-Spalten hochladen, um Masterpreise zu aktualisieren.',
    matchingInProgress: 'Abgleich läuft...',
    embeddingImages: 'Produktbilder werden analysiert...',
    enableImageMatching: 'Bildabgleich aktivieren',
    imageWeight: 'Bildgewichtung',
    imageMatchingDescription: 'Produktbilder vergleichen, um Übereinstimmungen zu bestätigen. Verwendet Perceptual Hashing für identische Bilder und visuelle KI für ähnliche Bilder.',
    // Knockout-Attribute
    knockout: 'Knockout',
    knockoutTooltip: 'Wenn dieses Attribut nicht übereinstimmt, wird das Produkt komplett abgelehnt',
    knockoutEnabled: 'Knockout aktiv',
    knockoutDisabled: 'Knockout inaktiv',
    // Attribute matching dialog
    primaryAttributesPreEnabled: 'Primäre Attribute (EAN, MPN, FEFCO etc.) sind voraktiviert — bei Bedarf ausschalten.',
    attributeSampleNote: 'Attribute basieren auf einer Stichprobe der ersten {count} Produkte. Für große Kataloge ergibt dies einen genauen Überblick.',
    matchingOverview: 'Matching Übersicht',
    matchDistribution: 'Match Verteilung',
    matchRate: 'Match-Rate',
    // Stats
    statProducts: 'Produkte gesamt',
    statMatched: 'Gematcht',
    statUnmatched: 'Nicht gematcht',
    statDomains: 'Quellen',
    statLanguages: 'Sprachen',
    statLanguageGroups: 'Sprachgruppen',
    statVariants: 'Mit Varianten',
    statTotalVariants: 'Varianten gesamt',
    tooltipVariants: 'Produkte mit mehreren Varianten (z.B. Größen, Farben, Optionen).',
    tooltipTotalVariants: 'Gesamtanzahl der Produktvarianten über alle Produkte mit Varianten.',
    tooltipLanguages: 'Anzahl der verschiedenen Sprachen, die über alle Produkte in dieser Analyse erkannt wurden.',
    tooltipLanguageGroups: 'Anzahl der sprachübergreifenden Produktgruppen: dasselbe Produkt über Sprachen hinweg verknüpft via EAN, hreflang oder übersetzten Namen.',
    // Tooltips
    tooltipTotalProducts: 'Gesamtanzahl der Master-Produkte aus Ihrer Hauptdomain, die verglichen werden können.',
    tooltipMatched: 'Produkte, die erfolgreich mit Vergleichsprodukten aus anderen Quellen gematcht wurden.',
    tooltipUnmatched: 'Produkte ohne Match. Erwägen Sie, die Match-Einstellungen anzupassen oder mehr Vergleichsdaten hinzuzufügen.',
    tooltipSources: 'Anzahl der verschiedenen Domains/Shops, die in dieser Analyse verglichen werden.',
    tooltipTier1: 'Tier 1: Exakte Matches basierend auf eindeutigen Identifikatoren wie EAN (Barcode) oder MPN (Herstellerartikelnummer). Höchste Konfidenz.',
    tooltipTier2: 'Tier 2: Matches basierend auf Produktattributen wie Name, Maße und Spezifikationen. Gute Konfidenz, aber ggf. Überprüfung nötig.',
    tooltipMatchRate: 'Prozentsatz der gematchten Produkte. Höher ist besser für umfassenden Preisvergleich.',
    // Pre-Filter Statistiken
    statPreFiltered: 'Vorgefiltert',
    tooltipPreFiltered: 'Wettbewerber-Produkte, die vom Pre-Filter für die Normalisierung ausgewählt wurden. Reduziert KI-Verarbeitungskosten bei maximaler Match-Qualität.',
    preFilterLabel: 'Pre-Filter',
    preFilterCrawled: 'gecrawlt',
    preFilterSelected: 'ausgewählt',
    preFilterNormalized: 'normalisiert',
    // Filters
    searchPlaceholder: 'Produkte suchen...',
    filterAll: 'Alle Produkte',
    filterMatched: 'Gematcht',
    filterUnmatched: 'Nicht gematcht',
    allDomains: 'Alle Quellen',
    allLanguages: 'Alle Sprachen',
    colLanguage: 'Sprache',
    // Table columns
    colProduct: 'Produkt',
    colSku: 'Art.-Nr.',
    colEan: 'EAN/MPN',
    colSource: 'Quelle',
    colPrice: 'Preis',
    colMatch: 'Match',
    colMatchScore: 'Score',
    colMasterPrice: 'Vgl.-Preis',
    colDifference: 'Differenz',
    // Match tiers
    tier1: 'EAN/MPN',
    tier2: 'Attribute',
    noMatch: 'Kein Match',
    noProducts: 'Keine Produkte gefunden',
    products: 'Produkten',
    // Table Headers (legacy)
    ean: 'EAN',
    sku: 'SKU',
    productName: 'Produktname',
    rrp: 'UVP',
    minPrice: 'Min. Preis',
    maxPrice: 'Max. Preis',
    calculatedPrice: 'Kalk. Preis',
    shipping: 'Versand',
    appliedRule: 'Angew. Regel',
    devLast: 'Abw. Letzte',
    devAppr: 'Abw. Freig.',
    // Tooltips (legacy)
    offersTooltip: 'Anzahl aktiver Angebote auf allen Plattformen',
    localMin: 'Lokal Min.',
    localMinTooltip: 'Niedrigster Preis in der lokalen Region',
    minSeller: 'Günstigster Händler',
    maxDev: 'Max. Abw.',
    maxDevTooltip: 'Maximale Abweichung vom UVP',
    range: 'Spanne',
    rangeTooltip: 'Differenz zwischen niedrigstem und höchstem Angebot',
    avgPrice: 'Ø Preis',
    rating: 'Bewertung',
    change: 'Änderung',
    // Filters (legacy)
    brand: 'Marke',
    type: 'Typ',
    productGroup: 'Produktgruppe',
    allStrategies: 'Alle Strategien',
    allResults: 'Alle Ergebnisse',
    priceChanged: 'Preis geändert',
    calcFailed: 'Kalk. fehlgeschlagen',
  },

  // ============================================================================
  // Module Names
  // ============================================================================
  modules: {
    companyInfo: 'Firmeninformationen',
    bestSellers: 'Bestseller',
    contactInfo: 'Kontaktinformationen',
    faq: 'FAQ',
    shippingInfo: 'Versandinfos',
    returnPolicy: 'Rückgaberichtlinien',
  },

  // ============================================================================
  // My Pricing
  // ============================================================================
  pricing: {
    title: 'Meine Preise',
    subtitle: 'Marktübersicht und Preisverwaltung.',
    addProduct: 'Produkt hinzufügen',
    searchPlaceholder: 'EAN, SKU oder Name...',
    // Status
    products: 'Produkte',
    pricingActive: 'Preisgestaltung aktiv',
    pricingInactive: 'Preisgestaltung inaktiv',
    pendingApproval: 'Wartet auf Freigabe',
    noOffers: 'Keine Angebote',
    // Stats
    priceIncreases: 'Preiserhöhungen',
    priceDecreases: 'Preissenkungen',
    unchanged: 'Unverändert',
    minPrice: 'Min. Preis',
    maxPrice: 'Max. Preis',
    rankDistribution: 'Rangverteilung',
    pricingActivity24h: 'Preisaktivität (24h)',
    statusOverview: 'Statusübersicht',
    // Table columns
    ean: 'EAN',
    sku: 'SKU',
    productName: 'Produktname',
    rrp: 'UVP',
    appliedRule: 'Angew. Regel',
    calculatedPrice: 'Kalk. Preis',
    shipping: 'Versand',
    devLast: 'Abw. Letzt.',
    devAppr: 'Abw. Freig.',
    // Filters
    ruleStrategy: 'Regelstrategie',
    allStrategies: 'Alle Strategien',
    allResults: 'Alle Ergebnisse',
    priceChanged: 'Preis geändert',
    calcFailed: 'Kalk. fehlgeschlagen',
    productGroup: 'Produktgruppe',
    allGroups: 'Alle Gruppen',
    electronics: 'Elektronik',
    furniture: 'Möbel',
    home: 'Haus & Garten',
    fashion: 'Mode',
    custom: 'Benutzerdefiniert',
  },

  // ============================================================================
  // Product Discovery
  // ============================================================================
  discovery: {
    title: 'Produktentdeckung',
    subtitle: 'Finden Sie Produkte, die Ihre Wettbewerber haben, Sie aber nicht.',
    searchProducts: 'Produkte suchen',
    discoverProducts: 'Produkte entdecken',
    searchPlaceholder: 'Produkte, Marken, EAN suchen...',
    noResults: 'Keine Produkte gefunden',
    addToMonitoring: 'Zur Überwachung hinzufügen',
    viewProduct: 'Produkt ansehen',
    // ProductDiscovery component
    selectJob: 'Wählen Sie einen Job zur Analyse',
    findProducts: 'Finden Sie Produkte Ihrer Wettbewerber',
    sortBy: 'Sortieren nach',
    sortOpportunity: 'Opportunitätswert',
    sortCoverage: 'Wettbewerber-Abdeckung',
    sortPriceLow: 'Preis: Niedrig zu Hoch',
    sortPriceHigh: 'Preis: Hoch zu Niedrig',
    sortName: 'Name A-Z',
    minCoverage: 'Min. Wettbewerber',
    any: 'Beliebig',
    atLeast: 'Mindestens',
    competitors: 'Wettbewerber',
    totalDiscoveries: 'Entdeckungen',
    competitorsAnalyzed: 'Wettbewerber',
    jobsAnalyzed: 'Jobs',
    masterDomain: 'Master Domain',
    noProducts: 'Keine Produkte entdeckt',
    noProductsDesc: 'Versuchen Sie, Filter anzupassen oder einen anderen Job auszuwählen.',
    priceRange: 'Preis',
    coverage: 'Abdeckung',
    coverageTooltip: 'Anzahl der Wettbewerber mit diesem Produkt',
    aiSourceTooltip: 'Dieses Produkt enthält KI-generierte Daten. Links und Bilder können ungenau sein.',
    source: 'Quelle',
    opportunityScoreTooltip: 'Höherer Wert = höhere Chance. Basiert auf Wettbewerber-Abdeckung und Preispotenzial.',
    opportunityScoreLabel: 'Opportunity Score',
    opportunityCoverage: 'Abdeckung (60%)',
    opportunityPrice: 'Preisfaktor (40%)',
    opportunityPoints: 'Pkt.',
    opportunityFormula: 'Score = (Abdeckung × 60) + (Preisfaktor × 40)',
    pricePotentialTooltip: 'Geschätzte Gewinnspanne basierend auf Preisabweichung.',
    products: 'Produkte',
    errorLoading: 'Fehler beim Laden der Produkte',
    viewDetails: 'Details',
    visit: 'Besuchen',
    details: 'Details',
    potential: 'Marge',
    uncategorized: 'Ohne Kategorie',
    popularSearches: 'Beliebt:',
  },

  // ============================================================================
  // Content Discovery (Search-based)
  // ============================================================================
  contentDiscovery: {
    title: 'Inhaltssuche',
    description: 'Suchen und erkunden Sie gecrawlte Inhalte mit Volltext- und semantischer Suche.',
    selectJob: 'Job auswählen',
    selectCrawl: 'Job & Crawl auswählen',
    crawlExecution: 'Crawl-Ausführung',
    noCrawlSelected: 'Kein Crawl ausgewählt',
    noCrawlSelectedDescription: 'Wählen Sie einen abgeschlossenen Crawl aus, um seinen Inhalt zu durchsuchen.',
    selectJobFirst: 'Job auswählen',
    selectJobFirstDescription: 'Wählen Sie ein Projekt, eine Aufgabe und einen Job, um verfügbare Crawl-Daten anzuzeigen.',
    noCrawlsFound: 'Keine abgeschlossenen Crawls für diese Aufgabe gefunden. Führen Sie zuerst einen Crawl-Job aus.',
    searchPlaceholder: 'Seiteninhalt, Titel, Beschreibungen durchsuchen...',
    semanticSearch: 'Semantische Suche',
    embeddingsReady: 'Embeddings bereit',
    generatingEmbeddings: 'Generiere...',
    noEmbeddings: 'Keine Embeddings',
    generate: 'Generieren',
    semanticSearchHelp: 'Die semantische Suche verwendet KI-Embeddings, um ähnliche Inhalte zu finden, auch wenn die exakten Wörter nicht übereinstimmen. Generieren Sie zuerst Embeddings, dann aktivieren Sie die semantische Suche.',
    filters: 'Filter',
    contentType: 'Inhaltstyp',
    pageType: 'Seitentyp',
    signals: 'Signale',
    applyFilters: 'Filter anwenden',
    resetFilters: 'Zurücksetzen',
    results: 'Ergebnisse',
    noResults: 'Keine Ergebnisse gefunden',
    enterSearch: 'Geben Sie einen Suchbegriff ein, um Inhalte zu finden',
    type: 'Typ',
    page: 'Seite',
    relevance: 'Score',
  },

  // ============================================================================
  // Product Discovery Detail
  // ============================================================================
  discoveryDetail: {
    productDetails: 'Produktdetails',
    priceComparison: 'Preisvergleich',
    graduatedPrices: 'Staffelpreise',
    competitor: 'Wettbewerber',
    price: 'Preis',
    quantity: 'Menge',
    brand: 'Marke',
    category: 'Kategorie',
    ean: 'EAN',
    mpn: 'MPN',
    noPrice: 'Kein Preis',
    cheapest: 'Günstigster',
    mostExpensive: 'Teuerster',
    avgPrice: 'Ø Preis',
    priceSpread: 'Preisspanne',
    notMatched: 'Nicht in Ihrem Katalog',
    error: 'Fehler beim Laden',
  },

  // ============================================================================
  // AI Advisor
  // ============================================================================
  aiAdvisor: {
    title: 'AI Strategie-Berater',
    subtitle: 'Echtzeit-Handlungsempfehlungen basierend auf künstlicher Intelligenz.',
    opportunityDetected: 'Chance erkannt',
    confidence: 'Konfidenz',
    impact: 'Gesch. Auswirkung',
    applyAction: 'Empfehlung anwenden',
    dismiss: 'Verwerfen',
    analyzingMarket: 'Analysiere Marktdaten...',
    opportunitiesFound: 'Chancen gefunden',
    reasoning: 'AI-Begründung',
    recommendedAction: 'Empfohlene Handlung',
    profitBoost: 'Gewinnsteigerung',
    revenueBoost: 'Umsatzsteigerung',
    stockRisk: 'Lagerrisiko',
    noOpportunities: 'Derzeit keine neuen Optimierungsmöglichkeiten erkannt.',
    // Status
    systemOnline: 'System Aktiv',
    systemPaused: 'System Pausiert',
    allCaughtUp: 'Alles erledigt!',
    // Pricing
    currentPrice: 'Aktueller Preis',
    recommended: 'Empfohlen',
    // Live Analysis
    liveAnalysis: 'Live-Analyse',
    status: 'STATUS',
    online: 'ONLINE',
    offline: 'OFFLINE',
    latency: 'LATENZ',
    processed24h: 'Verarbeitet (24h)',
    accuracy: 'Genauigkeit',
    // Resource Control
    resourceControl: 'Ressourcenverwaltung',
    activeAnalysis: 'Aktive Analyse',
    runIndefinitely: 'Unbegrenzt ausführen',
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    apiCreditsWarning: 'Laufende Analyse verbraucht API-Guthaben.',
    // Coming Soon
    comingSoon: 'Demnächst verfügbar',
    comingSoonDescription: 'KI-gestützte Preisempfehlungen und Marktanalysen werden in einem zukünftigen Update verfügbar sein.',
  },

  // ============================================================================
  // AI Provider Status
  // ============================================================================
  aiProvider: {
    issue: 'KI-Provider-Problem',
    degradedPerformance: 'eingeschränkte Leistung',
    outage: 'Ausfall',
    pipelineMayBeAffected: 'Pipeline-Ausführungen können betroffen sein.',
    checkApiKeys: 'Überprüfen Sie Ihre KI-Provider-API-Schlüssel unter Einstellungen → KI-Modelle.',
  },

  // ============================================================================
  // Sellers / Competitors
  // ============================================================================
  sellers: {
    title: 'Händlerübersicht',
    subtitle: 'Umfassende Analyse aller gecrawlten Wettbewerber über alle Preisanalyse-Jobs.',
    totalSellers: 'Händler gesamt',
    activeSellers: 'Aktive Händler',
    newSellers: 'Neue Händler',
    sellerName: 'Händlername',
    platform: 'Plattform',
    products: 'Produkte',
    offers: 'Angebote',
    avgRating: 'Ø Bewertung',
    belowRrp: 'Unter UVP',
    lastSeen: 'Zuletzt gesehen',
    // SellerOverview specific
    mostOffers: 'Meiste Angebote',
    mostPriceLeaders: 'Meiste Preisführerschaften',
    highestDeviation: 'Höchste Ø-Abweichung',
    searchPlaceholder: 'Händler suchen...',
    seller: 'Händler',
    sellers: 'Händlern',
    leader: 'Preisführer',
    leaderPct: 'Preisführer %',
    assortmentPct: 'Sortiment %',
    deviation: 'Ø Abweichung',
    status: 'Status',
    tooltipOffers: 'Gesamtzahl der Produktangebote dieses Händlers',
    tooltipProducts: 'Anzahl einzigartiger Produkte',
    tooltipLeader: 'Produkte, bei denen dieser Händler den niedrigsten Preis hat',
    tooltipAssortment: 'Anteil der preisführenden Produkte an allen Master-Produkten',
    tooltipStatus: 'Grün: Günstiger, Gelb: Ähnlich, Rot: Teurer als Master',
    tooltipDeviation: 'Durchschnittliche Preisabweichung von Master-Produkten',
    lastCrawled: 'Zuletzt gecrawlt',
    jobsCount: 'Analysiert in Jobs',
    noSellersFound: 'Keine Händler gefunden',
    noData: 'Keine Händlerdaten verfügbar. Führen Sie Preisanalyse-Jobs mit aktiviertem Matching aus, um Wettbewerberdaten zu sehen.',
    errorLoading: 'Fehler beim Laden der Händlerdaten',
    jobsAnalyzed: 'Analysierte Jobs',
    totalOffersStat: 'Gesamte Angebote',
    totalProductsStat: 'Gesamte Produkte',
  },

  // ============================================================================
  // Settings
  // ============================================================================
  settings: {
    title: 'Einstellungen',
    description: 'Konfigurieren Sie Crawler, Proxies und Integrationen.',
    adminRequired: 'Administratorzugriff erforderlich',
    adminRequiredDescription: 'Sie benötigen Administratorrechte, um auf diesen Bereich zuzugreifen. Wenden Sie sich an Ihren Systemadministrator.',
    // Tabs
    tabs: {
      team: 'Team & Benutzer',
      proxies: 'Proxies & Netzwerk',
      api: 'API & Integrationen',
      ai: 'KI-Modelle',
      billing: 'Abrechnung & Guthaben',
    },
    general: 'Allgemein',
    proxies: 'Proxies & Netzwerk',
    api: 'API & Integrationen',
    email: 'E-Mail / SMTP',
    users: 'Team & Benutzer',
    systemLog: 'Systemprotokoll',
    // General
    maxConcurrency: 'Max. Parallelität',
    requestTimeout: 'Anfrage-Timeout (ms)',
    userAgentStrategy: 'User-Agent-Strategie',
    logRetentionDays: 'Log-Aufbewahrung (Tage)',
    // Proxy
    proxySettings: 'Proxy-Einstellungen',
    proxyEnabled: 'Proxy aktivieren',
    proxyType: 'Proxy-Typ',
    proxyHost: 'Proxy-Host',
    proxyPort: 'Proxy-Port',
    proxyUsername: 'Proxy-Benutzername',
    proxyPassword: 'Proxy-Passwort',
    proxyCountry: 'Proxy-Land',
    testProxy: 'Verbindung testen',
    proxyConnected: 'Proxy erfolgreich verbunden',
    proxyFailed: 'Proxy-Verbindung fehlgeschlagen',
    // API
    apiKeys: 'API-Schlüssel',
    anthropicApiKey: 'Anthropic API-Schlüssel',
    openaiApiKey: 'OpenAI API-Schlüssel',
    geminiApiKey: 'Gemini API-Schlüssel',
    testApi: 'API testen',
    apiConnected: 'API erfolgreich verbunden',
    apiFailed: 'API-Verbindung fehlgeschlagen',
    // Email
    emailSettings: 'E-Mail-Einstellungen',
    smtpServer: 'SMTP-Server',
    smtpPort: 'SMTP-Port',
    smtpUsername: 'SMTP-Benutzername',
    smtpPassword: 'SMTP-Passwort',
    smtpEncryption: 'Verschlüsselung',
    smtpSenderName: 'Absendername',
    smtpSenderEmail: 'Absender-E-Mail',
    testEmail: 'Test-E-Mail senden',
    emailSent: 'Test-E-Mail erfolgreich gesendet',
    emailFailed: 'Test-E-Mail konnte nicht gesendet werden',
    // Users
    userManagement: 'Benutzerverwaltung',
    addUser: 'Benutzer hinzufügen',
    editUser: 'Benutzer bearbeiten',
    deleteUser: 'Benutzer löschen',
    username: 'Benutzername',
    role: 'Rolle',
    lastLogin: 'Letzte Anmeldung',
    resetPassword: 'Passwort zurücksetzen',
    changeRole: 'Rolle ändern',
    adminAccessRequired: 'Admin-Zugang erforderlich',
    adminAccessDescription: 'Sie benötigen Administratorrechte, um auf diesen Bereich zuzugreifen. Kontaktieren Sie Ihren Systemadministrator.',
    // Roles
    roleAdmin: 'Admin',
    roleUser: 'Benutzer',
    roleViewer: 'Betrachter',
    // System Log
    systemLogs: 'Systemprotokolle',
    containerLogs: 'Container-Logs',
    selectContainer: 'Container auswählen',
    clearLogs: 'Logs löschen',
    downloadLogs: 'Logs herunterladen',
    streaming: 'Streaming',
    noLogs: 'Keine Logs verfügbar',
    // Saved
    settingsSaved: 'Einstellungen erfolgreich gespeichert',
    settingsFailed: 'Einstellungen konnten nicht gespeichert werden',
  },

  // ============================================================================
  // Feedback
  // ============================================================================
  feedback: {
    title: 'Feedback senden',
    subtitle: 'Teilen Sie Ihre Ideen, melden Sie Probleme oder stellen Sie Fragen.',
    sendFeedback: 'Feedback senden',
    closeFeedback: 'Feedback schließen',
    shareIdeas: 'Teilen Sie Ideen, melden Sie Fehler oder wünschen Sie Funktionen.',
    failedToSubmit: 'Feedback konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
    feedbackType: 'Typ',
    featureRequest: 'Feature-Anfrage',
    improvement: 'Verbesserung',
    bugReport: 'Fehlermeldung',
    question: 'Frage',
    other: 'Sonstiges',
    priority: 'Priorität',
    priorityLow: 'Niedrig',
    priorityMedium: 'Mittel',
    priorityHigh: 'Hoch',
    priorityCritical: 'Kritisch',
    feedbackTitle: 'Titel',
    feedbackTitlePlaceholder: 'Kurze Zusammenfassung Ihres Feedbacks',
    feedbackDescription: 'Beschreibung',
    feedbackDescriptionPlaceholder: 'Bitte beschreiben Sie ausführlich...',
    titlePlaceholder: 'Kurze Zusammenfassung Ihres Feedbacks...',
    descriptionPlaceholder: 'Bitte geben Sie Details zu Ihrem Feedback an...',
    typeLabel: 'Feedback-Typ',
    priorityLabel: 'Priorität',
    component: 'Komponente (Optional)',
    componentPlaceholder: 'Welcher Teil der App?',
    submitFeedback: 'Feedback senden',
    submitting: 'Wird gesendet...',
    thankYou: 'Vielen Dank für Ihr Feedback!',
    feedbackReceived: 'Wir haben Ihr Feedback erhalten und werden es in Kürze prüfen.',
    submitError: 'Feedback konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
    titleMinLength: 'Der Titel muss mindestens 5 Zeichen lang sein',
    descriptionMinLength: 'Die Beschreibung muss mindestens 10 Zeichen lang sein',
  },

  // ============================================================================
  // Abrechnung
  // ============================================================================
  billing: {
    title: 'Abrechnung & Credits',
    subtitle: 'Verwalten Sie Ihr Abonnement, Credits und Zahlungsmethoden',
    creditBalance: 'Credit-Guthaben',
    monthlyUsage: 'Monatlicher Verbrauch',
    currentPlan: 'Aktueller Plan',
    reserved: 'reserviert',
    total: 'gesamt',
    ofLimit: 'vom Limit',
    tier: 'Stufe',
    renewsOn: 'Verlängert am',
    noSubscription: 'Kein aktives Abonnement',
    buyCredits: 'Credits kaufen',
    credits: 'Credits',
    buy: 'Kaufen',
    usageBreakdown: 'Verbrauch diesen Monat',
    creditPricing: 'Credit-Preise',
    recentInvoices: 'Letzte Rechnungen',
    invoice: 'Rechnung',
    managePayment: 'Zahlung verwalten',
    adminOnly: 'Die Abrechnungsverwaltung ist auf Administratoren beschränkt.',
    loadError: 'Abrechnungsinformationen konnten nicht geladen werden',
    checkoutError: 'Checkout-Sitzung konnte nicht erstellt werden',
    portalError: 'Zahlungsportal konnte nicht geöffnet werden',
    comingSoon: 'Abrechnung & Credits',
    comingSoonDescription: 'Credit-Verwaltung, Verbrauchsübersicht und Zahlungshistorie werden in einem zukünftigen Update verfügbar sein.',
    platform_upsell_title: 'Plattform-Add-On nicht aktiv',
    platform_upsell_description: 'Überwachen Sie Amazon, eBay, Idealo, Otto und mehr mit dem Plattform-Add-On.',
    platform_upsell_cta: 'Plattform-Add-On buchen',
    platform_upsell_price: 'Ab €79/Monat',
    credits_available: '{{count}} Credits',
    credits_low: 'Credits niedrig',
    credits_depleted: 'Keine Credits',
    credits_required_short: 'erforderlich',
    // Settings tab billing keys
    settings_tab_title: 'Abrechnung & Credits',
    credit_balance: 'Guthaben',
    subscription_credits: 'Abo-Credits',
    purchased_credits: 'Gekaufte Credits',
    reserved_credits: 'Reserviert',
    available_credits: 'Verfügbar',
    expires: 'Läuft ab {{date}}',
    never_expires: 'Läuft nicht ab',
    current_plan: 'Aktueller Tarif',
    renews_on: 'Verlängert am {{date}}',
    upgrade_plan: 'Tarif upgraden',
    manage_subscription: 'Abo verwalten',
    payment_history: 'Zahlungsverlauf',
    no_payments: 'Noch keine Zahlungen.',
    buy_credits: 'Credits kaufen',
    manage_payment: 'Zahlungsmethode verwalten',
    invoice_date: 'Datum',
    invoice_amount: 'Betrag',
    invoice_status: 'Status',
    invoice_pdf: 'PDF',
    // Trial & Setup-Bonus
    trial_active: 'Kostenlose Testphase',
    trial_days_remaining: 'Noch {{count}} Tage',
    trial_subscribe_cta: 'Jetzt abonnieren',
    trial_ends_soon: 'Testphase endet in {{count}} Tagen',
    setup_bonus_title: 'Willkommensbonus aktiv!',
    setup_bonus_description: '+25% Bonus-Credits für den ersten Monat',
    setup_bonus_value: 'Das entspricht €{{amount}} an zusätzlichen Credits',
    // Abrechnungsseite
    credit_packs_title: 'Credits kaufen',
    credit_packs_subtitle: 'Guthaben mit einmaligen Paketen aufladen',
    usage_chart_title: 'Kreditverbrauch nach Aktion',
    usage_chart_empty: 'Keine Verbrauchsdaten für diesen Zeitraum.',
    // Enterprise-Deployment
    enterprise_subtitle: 'Enterprise-Deployment – Abrechnung extern verwaltet',
    enterprise_banner_title: 'Enterprise-Deployment',
    enterprise_badge: 'Enterprise',
    enterprise_banner_subtitle: 'Dies ist ein individuelles Enterprise-Deployment ohne Credit-Limits.',
    enterprise_no_credits_title: 'Keine Credit-Kontrolle',
    enterprise_no_credits_desc: 'Alle Operationen laufen gegen Ihre eigenen API-Keys. Der Verbrauch wird nicht in der Anwendung erfasst.',
    enterprise_billing_title: 'Rechnungsstellung',
    enterprise_billing_desc: 'Ihr Abonnement wird per Rechnung abgerechnet. Rechnungen und Verbrauchsberichte erhalten Sie von Ihrem Ansprechpartner.',
    enterprise_contact_prefix: 'Fragen zu Ihrer Rechnung oder Ihrem Abonnement?',
    // Plankatalog
    plans_title: 'Verfügbare Tarife',
    plans_subtitle: 'Übersicht aller Abonnement-Tarife',
    plans_per_month: '/Monat',
    plans_included_credits: '{{count}} Credits / Monat',
    plans_platform_credits: '+ {{count}} Plattform-Credits',
    plans_platform_credits_first_purchase: 'nur beim ersten Kauf',
    plans_platform_addon: 'Plattform-Add-On +{{price}}/Monat',
    plans_unlimited: 'Unbegrenzte Credits',
    plans_free: 'Individueller Preis',
    plans_max_competitors: 'Bis zu {{count}} Wettbewerbern',
    // Abrechnungskonto
    account_title: 'Abrechnungskonto',
    account_email_label: 'Abrechnungskontakt',
    account_domain_label: 'Deployment-Domain',
    account_status_label: 'Status',
    account_email_note: 'Stellen Sie sicher, dass diese E-Mail-Adresse mit dem bei der Bestellung verwendeten Konto übereinstimmt. Kontaktieren Sie den Support, wenn sie abweichen.',
    account_manage: 'Abonnement verwalten',
    account_cancel: 'Abonnement kündigen',
  },

  // ============================================================================
  // Roadmap
  // ============================================================================
  roadmap: {
    title: 'Produkt-Roadmap',
    subtitle: 'Entdecken Sie kommende Funktionen und geplante Verbesserungen der Plattform',
    // Status labels
    status: {
      completed: 'Abgeschlossen',
      inProgress: 'In Bearbeitung',
      planned: 'Geplant',
      future: 'Zukünftig',
    },
    // Feature request section
    featureRequest: {
      title: 'Haben Sie einen Feature-Wunsch?',
      description: 'Teilen Sie Ihre Ideen und gestalten Sie die Zukunft der Plattform mit',
      hideForm: 'Formular ausblenden',
      submitFeedback: 'Feedback senden',
    },
    // Feedback form
    feedbackForm: {
      title: 'Ihr Feedback',
      description: 'Teilen Sie uns Ihre Idee mit, melden Sie einen Fehler oder stellen Sie eine Frage. Wir lesen jede Einsendung!',
    },
    // API Documentation section
    apiDocs: {
      title: 'API-Dokumentation',
      description: 'Interaktive OpenAPI-Dokumentation für alle Services',
      scrapingService: 'Scraping Service',
      scrapingServiceDesc: 'Projekte, Aufgaben, Jobs',
      userService: 'User Service',
      userServiceDesc: 'Auth, Benutzer, Einstellungen',
      crawlerService: 'Crawler Service',
      crawlerServiceDesc: 'Crawling, Extraktion, Matching',
    },
    // Roadmap items
    items: {
      priceHistory: {
        title: 'Preisverlauf & Tracking',
        description: 'Verfolgen Sie Preisänderungen der Wettbewerber über Zeit mit detaillierten Charts und historischen Analysen.',
        features: {
          charts: 'Historische Preischarts für alle Produkte',
          notifications: 'Benachrichtigungen bei Preisänderungen',
          trends: 'Trendanalyse und Prognosen',
          export: 'Historische Daten exportieren',
        },
      },
      mlPredictions: {
        title: 'ML-gestützte Preisprognosen',
        description: 'Nutzen Sie maschinelles Lernen zur Vorhersage optimaler Preisstrategien basierend auf Marktdaten.',
        features: {
          recommendations: 'KI-gesteuerte Preisempfehlungen',
          forecasting: 'Nachfrageprognose',
          prediction: 'Vorhersage des Wettbewerberverhaltens',
          automated: 'Automatisierte Preisvorschläge',
        },
      },
      shopConnectors: {
        title: 'Shop-System Konnektoren',
        description: 'Nahtlose Integration mit beliebten E-Commerce-Plattformen für automatische Preissynchronisation.',
        features: {
          shopware: 'Shopware 6 Integration',
          woocommerce: 'WooCommerce Konnektor',
          shopify: 'Shopify Integration',
          autoUpdate: 'Automatische Preisaktualisierungen',
        },
      },
      scheduledCrawling: {
        title: 'Geplantes Crawling',
        description: 'Richten Sie automatische Crawl-Zeitpläne ein, um Ihre Daten ohne manuellen Eingriff aktuell zu halten.',
        features: {
          cron: 'Cron-basierte Planung',
          priority: 'Prioritätsbasierte Warteschlange',
          rateLimit: 'Rate-Limit-Verwaltung',
          monitoring: 'Crawl-Gesundheitsüberwachung',
        },
      },
      marketplaceCrawling: {
        title: 'Marktplatz-Crawling',
        description: 'Erweitern Sie die Crawling-Fähigkeiten auf große Marktplätze wie Amazon und Idealo.',
        features: {
          amazon: 'Amazon Preisverfolgung',
          idealo: 'Idealo Integration',
          ebay: 'eBay Überwachung',
          multiMarket: 'Multi-Marktplatz-Vergleich',
        },
      },
      aiAdvisorFull: {
        title: 'AI Advisor',
        description: 'Vollständiger KI-gestützter Preisberater mit natürlichsprachlichen Erkenntnissen und Empfehlungen.',
        features: {
          nlQueries: 'Natürlichsprachliche Abfragen',
          reports: 'Automatisierte Berichte',
          strategic: 'Strategische Empfehlungen',
          intelligence: 'Marktintelligenz-Zusammenfassungen',
        },
      },
      tokenization: {
        title: 'Tokenisierung & Kreditsystem',
        description: 'Nutzungsbasiertes Kreditsystem mit Stripe-Zahlungsintegration für SaaS-Abrechnung.',
        features: {
          credits: 'Token-basiertes Kreditsystem',
          stripe: 'Stripe-Zahlungsintegration',
          usage: 'Nutzungsverfolgung & Messung',
          tiers: 'Abo-Stufen-Verwaltung',
        },
      },
      dynamicPricing: {
        title: 'Dynamische Preisgestaltung',
        description: 'Automatisierte regelbasierte Preis-Engine, die Preise basierend auf Marktbedingungen und Wettbewerberdaten anpasst.',
        features: {
          rules: 'Regelbasierte Preisstrategien',
          automation: 'Automatisierte Preisanpassungen',
          margins: 'Margenschutz & Leitplanken',
          sync: 'Shop-System Preissynchronisation',
        },
      },
    },
    // Legacy keys (keep for compatibility)
    planned: 'Geplant',
    inProgress: 'In Bearbeitung',
    completed: 'Abgeschlossen',
    requestFeature: 'Feature anfragen',
    upvote: 'Upvote',
    noItems: 'Keine Roadmap-Einträge verfügbar',
  },

  // ============================================================================
  // Theme / Appearance
  // ============================================================================
  theme: {
    darkMode: 'Dunkelmodus',
    lightMode: 'Heller Modus',
    systemDefault: 'Systemstandard',
    language: 'Sprache',
  },

  // ============================================================================
  // Errors
  // ============================================================================
  errors: {
    generic: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    notFound: 'Seite nicht gefunden',
    notFoundDescription: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
    unauthorized: 'Nicht autorisiert',
    unauthorizedDescription: 'Sie haben keine Berechtigung, auf diese Seite zuzugreifen.',
    serverError: 'Serverfehler',
    serverErrorDescription: 'Auf dem Server ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
    networkError: 'Netzwerkfehler',
    networkErrorDescription: 'Verbindung zum Server nicht möglich. Bitte überprüfen Sie Ihre Internetverbindung.',
    timeout: 'Zeitüberschreitung',
    timeoutDescription: 'Die Anfrage hat zu lange gedauert. Bitte versuchen Sie es erneut.',
    goHome: 'Zur Startseite',
    goBack: 'Zurück',
  },

  // ============================================================================
  // Validation
  // ============================================================================
  validation: {
    required: 'Dieses Feld ist erforderlich',
    email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    minLength: 'Muss mindestens {{min}} Zeichen lang sein',
    maxLength: 'Darf höchstens {{max}} Zeichen lang sein',
    passwordMatch: 'Passwörter stimmen nicht überein',
    invalidUrl: 'Bitte geben Sie eine gültige URL ein',
    invalidNumber: 'Bitte geben Sie eine gültige Zahl ein',
  },

  // ============================================================================
  // Time
  // ============================================================================
  time: {
    seconds: 'Sekunden',
    minutes: 'Minuten',
    hours: 'Stunden',
    days: 'Tage',
    weeks: 'Wochen',
    months: 'Monate',
    years: 'Jahre',
    justNow: 'Gerade eben',
    last30Days: 'Letzte 30 Tage',
    last7Days: 'Letzte 7 Tage',
    last24Hours: 'Letzte 24 Stunden',
  },

  // ============================================================================
  // Product Detail
  // ============================================================================
  productDetail: {
    title: 'Produktdetails',
    subtitle: 'Detaillierte Analyse und Preisvergleich',
    masterProduct: 'Master-Produkt',
    match: 'Match',
    matches: 'Matches',
    share: 'Teilen',
    report: 'Bericht',
    graduatedPrices: 'Staffelpreise',
    graduatedPricesTooltip: 'Dieses Produkt hat mengenabhängige Preise (Staffelpreise). Vergleichen Sie Preise über verschiedene Mengenstufen unten.',
    graduatedPricesDescription: 'Mehrere Preisstufen erkannt. Nutzen Sie die Vergleichstabelle unten, um Preise über verschiedene Bestellmengen zu vergleichen.',
    yourPrices: 'Ihre Preise',
    bestPricePerTier: 'Bester Preis pro Stufe',
    priceTierComparison: 'Preisstufen-Vergleich',
    priceTiers: 'Preisstufen',
    inclTax: 'Inkl. MwSt.',
    exclTax: 'Exkl. MwSt.',
    allMatches: 'Alle Matches',
    searchMatches: 'Matches suchen...',
    noMatches: 'Keine Matches gefunden',
    domain: 'Anbieter',
    productName: 'Produktname',
    matchColumn: 'Match',
    matchTooltip: 'Match-Stufe: Stufe 1 = EAN/MPN exakte Übereinstimmung, Stufe 2 = Attribut-Ähnlichkeit',
    score: 'Score',
    price: 'Preis',
    priceTooltip: 'Basispreis (niedrigste Mengenstufe bei Staffelpreisen)',
    difference: 'Differenz',
    differenceTooltip: 'Preisdifferenz im Vergleich zu Ihrem Master-Preis',
    matchDetails: 'Match-Details',
    productImages: 'Produktbilder',
    alsoAvailableIn: 'Auch verfügbar in',
    languageSiblings: 'Sprachversionen',
    viewInLanguage: 'Anzeigen in',
    // Variants
    variants: 'Varianten',
    variantsTooltip: 'Produktvarianten (Größen, Farben, Optionen) aus Schema.org-Daten, Plattform-APIs oder Seiteninteraktion extrahiert.',
    variantLabel: 'Variante',
    variantSku: 'SKU',
    variantEan: 'EAN',
    variantPrice: 'Preis',
    variantStock: 'Auf Lager',
    variantSource: 'Quelle',
    variantAttributes: 'Attribute',
    variantDimensions: 'Dimensionen',
    noVariants: 'Keine Varianten für dieses Produkt erkannt.',
    variantComparison: 'Varianten-Vergleich',
    variantComparisonTooltip: 'Varianten zwischen diesem Produkt und dem gematchten Produkt vergleichen.',
    variantOverlapping: 'Übereinstimmende Varianten',
    variantMasterOnly: 'Nur im Master',
    variantCompetitorOnly: 'Nur beim Wettbewerber',
    variantOverlapRatio: 'Übereinstimmung',
    variantPriceDiff: 'Preisdiff.',
    variantPriceThis: 'Dieses Produkt',
    variantPriceMatch: 'Match',
    hasVariants: 'Varianten',
  },

  // ============================================================================
  // Match-Überschreibungen
  // ============================================================================
  matching: {
    acceptMatch: 'Match akzeptieren',
    rejectMatch: 'Match ablehnen',
    manuallyAccepted: 'Manuell akzeptiert',
    manuallyRejected: 'Manuell abgelehnt',
    undoOverride: 'Rückgängig',
    overrideReason: 'Grund (optional)',
    attributeGroups: 'Attribut-Synonymgruppen',
    addGroup: 'Gruppe hinzufügen',
    addSynonym: 'Synonym hinzufügen…',
    groupName: 'Gruppenname',
    synonymsHelp: 'Attribute in derselben Gruppe werden beim Matching als gleichwertig behandelt.',
  },

  // ============================================================================
  // Preisverlauf
  // ============================================================================
  priceHistory: {
    title: 'Preisverlauf',
    noData: 'Noch kein Preisverlauf verfügbar. Daten erscheinen nach dem ersten erneuten Durchlauf.',
    current: 'Aktuell',
    allTimeLow: 'Allzeittief',
    allTimeHigh: 'Allzeithoch',
    average: 'Durchschnitt',
    changes: 'Änderungen',
    timeRange7d: '7 Tage',
    timeRange30d: '30 Tage',
    timeRange90d: '90 Tage',
    timeRange1y: '1 Jahr',
    timeRangeAll: 'Alle',
    tiers: 'Staffeln',
    basePrice: 'Grundpreis',
    quantity: 'Menge',
    loadError: 'Preisverlauf konnte nicht geladen werden',
    competitors: 'Wettbewerber',
    showCompetitors: 'Wettbewerberpreise anzeigen',
    masterPrice: 'Ihr Preis',
    noCompetitorData: 'Keine Wettbewerber-Preishistorie verfügbar',
    configChanged: 'Config geändert',
    matchAdded: 'Wettbewerber hinzugefügt',
    matchRemoved: 'Wettbewerber entfernt',
    matchEvents: 'Match-Änderungen',
  },

  // ============================================================================
  // CSV-URLs Tab (Aufgabe bearbeiten)
  // ============================================================================
  csvUrls: {
    tab: 'CSV-URLs',
    description: 'Laden Sie eine CSV-Datei mit URLs hoch, die gecrawlt werden sollen. Diese URLs werden von allen Jobs dieser Aufgabe verwendet.',
    settingsTab: 'Einstellungen',
    saveFirst: 'Speichern Sie die Aufgabe zuerst, um Dateien hochzuladen',
  },

  // ============================================================================
  // Katalogmodus
  // ============================================================================
  catalog: {
    modeLabel: 'Upload-Modus',
    modeUrl: 'URL-Modus',
    modeUrlDescription: 'Produkt-URLs crawlen, um Preise zu extrahieren und zu vergleichen.',
    modeCatalog: 'Katalog-Modus',
    modeCatalogDescription: 'Produktkatalog (CSV) mit Namen und EANs hochladen. Plattformen werden direkt durchsucht.',
    tab: 'Katalog',
    settingsTab: 'Einstellungen',
    description: 'Laden Sie eine CSV mit Produktnamen und EANs hoch. Das System durchsucht Plattformen direkt — kein Master-URL-Crawling nötig.',
    resultsPerPlatform: 'Ergebnisse pro Plattform',
    resultsPerPlatformDescription: 'Anzahl der Suchergebnisse pro Plattform pro Produkt (1-5).',
    dropOrClick: 'Katalog-CSV hierher ziehen oder klicken zum Durchsuchen',
    limits: 'Max. 5MB, bis zu 10.000 Produkte',
    uploading: 'Katalog wird hochgeladen...',
    uploadSuccess: '{{count}} Produkte erfolgreich hochgeladen',
    uploadFailed: 'Katalog-Upload fehlgeschlagen',
    productsUploaded: 'Produkte hochgeladen',
    missingEan: '{{count}} Produkte ohne EAN',
    replaceCsv: 'CSV ersetzen',
    clearAll: 'Alle löschen',
    clearSuccess: 'Katalog gelöscht',
    eanSearch: 'EAN-Suche',
    nameSearch: 'Namenssuche',
    platformNoMasterRequired: 'Plattformen zum Durchsuchen auswählen. Kein Master-URL im Katalogmodus erforderlich.',
    languageTitle: 'Ergebnissprache',
    languageLabel: 'Sprache',
    languageDescription: 'Wählen Sie die Sprache, in der Sie Suchergebnisse erhalten möchten. Die Plattform-Locale (z.B. Amazon DE vs. Amazon FR) wird durch Ihre Plattformauswahl oben bestimmt.',
    languageHint: 'Diese Sprache wird für den Produktnamenabgleich und die Ergebnisfilterung verwendet. Plattformspezifische Locales werden automatisch anhand Ihrer ausgewählten Plattformen behandelt.',
    modeLocked: 'Gesperrt — Modus kann nach Erstellung von Jobs nicht mehr geändert werden',
    totalProducts: '{{count}} Katalogprodukte',
    downloadCsv: 'CSV herunterladen',
    colName: 'Name',
    colEan: 'EAN',
    colPrice: 'Preis',
    csvColumnsHint: 'Erforderlich: "name", "ean". Optional: "price", "currency", "external_id", "variant_id".',
  },

  // ============================================================================
  // CSV URL Upload
  // ============================================================================
  csvUpload: {
    dropOrClick: 'CSV-Datei hierher ziehen oder klicken zum Durchsuchen',
    limits: 'Max. 25MB (kein URL-Limit)',
    uploading: 'Wird hochgeladen...',
    uploadSuccess: '{{count}} URLs erfolgreich hochgeladen',
    uploadFailed: 'Upload fehlgeschlagen',
    fileTooLarge: 'Datei ist zu groß. Maximale Größe ist 5MB.',
    invalidFileType: 'Ungültiger Dateityp. Bitte laden Sie eine .csv oder .txt Datei hoch.',
    urlsUploaded: 'URLs hochgeladen',
    replaceCsv: 'CSV ersetzen',
    clearAll: 'Alle löschen',
    clearSuccess: '{{count}} URLs gelöscht',
    clearFailed: 'URLs konnten nicht gelöscht werden',
    invalidUrls: 'ungültige URLs übersprungen',
    row: 'Zeile',
    more: 'weitere',
    languageMismatch: 'TLD/Sprache-Abweichung erkannt',
    configuredAs: 'konfiguriert als',
    duplicatesSkipped: 'doppelte URLs übersprungen',
    csvColumnsTitle: 'CSV-Spalten:',
    csvColumnsRequired: 'Erforderlich',
    csvColumnsOptional: 'Optional',
    csvColumnsHint: 'Kopfzeile ist erforderlich. Trennzeichen wird automatisch erkannt (Komma oder Semikolon).',
  },

  // ============================================================================
  // Uploaded URLs List
  // ============================================================================
  uploadedUrls: {
    title: 'Hochgeladene URLs',
    total: '{{count}} URLs insgesamt',
    downloadCsv: 'CSV herunterladen',
    pending: 'Ausstehend',
    crawled: 'Gecrawlt',
    failed: 'Fehlgeschlagen',
    skipped: 'Übersprungen',
    filterAll: 'Alle Status',
    noLabel: '—',
    noLanguage: '—',
    page: 'Seite {{page}} von {{totalPages}}',
    previous: 'Zurück',
    next: 'Weiter',
    errorDetails: 'Fehlerdetails',
    empty: 'Keine URLs hochgeladen',
    loading: 'URLs werden geladen...',
    showUrls: 'Anzeigen ({{count}})',
    hideUrls: 'Ausblenden',
  },

  // ============================================================================
  // Crawl Entry Seeds
  // ============================================================================
  entrySeeds: {
    label: 'Crawl-Einstiegspunkte',
    description: 'Der Crawler startet von diesen Seiten und folgt allen verlinkten Produktseiten. Leer lassen, um von der Domain-Startseite zu beginnen.',
    placeholder: '/produkte/ oder https://domain.com/produkte/',
  },

  // Master Data Import
  masterData: {
    title: 'Stammdaten importieren',
    description: 'Stammdaten für {{domain}} vorab einpflegen',
    howItWorks: 'Laden Sie Ihre eigenen Produktdaten als CSV hoch. Die Pipeline überspringt das Crawlen Ihres Shops und verwendet diese Daten direkt für den Abgleich mit Wettbewerbern.',
    expectedColumns: 'Erwartete Spalten:',
    requiredColumn: '* = erforderlich',
    dropCsv: 'CSV-Datei hier ablegen oder',
    clickBrowse: 'zum Durchsuchen klicken',
    csvOnly: 'CSV oder TXT, max. 25MB',
    importAndContinue: 'Importieren & Fortfahren',
    uploadAnother: 'Weitere hochladen',
    imported: '{{count}} Produkte importiert',
    buttonImport: 'Stammdaten importieren',
    noMasterDomain: 'Legen Sie zuerst eine Master-URL fest, um Produktdaten zu importieren.',
  },

  // Connectors
  connectors: {
    title: 'Shop-Anbindungen',
    description: 'Verbinden Sie Ihr Shopsystem, um Stammdaten automatisch zu synchronisieren.',
    addConnector: 'Anbindung hinzufügen',
    testConnection: 'Verbindung testen',
    syncNow: 'Jetzt synchronisieren',
    lastSync: 'Letzte Sync: {{date}}',
    never: 'Nie',
    shopware: 'Shopware 6',
    shopify: 'Shopify',
    woocommerce: 'WooCommerce',
    apiUrl: 'API-URL',
    clientId: 'Client-ID',
    clientSecret: 'Client-Secret',
    salesChannelId: 'Verkaufskanal-ID',
    storeUrl: 'Store-URL',
    accessToken: 'Access-Token',
    consumerKey: 'Consumer-Key',
    consumerSecret: 'Consumer-Secret',
    connectionSuccess: 'Verbindung erfolgreich!',
    connectionFailed: 'Verbindung fehlgeschlagen. Prüfen Sie Ihre Zugangsdaten.',
    syncSuccess: '{{count}} Produkte synchronisiert',
    syncFailed: 'Synchronisierung fehlgeschlagen',
    noConnectors: 'Noch keine Shop-Anbindungen',
    noConnectorsDesc: 'Verbinden Sie Ihren Shopware-, WooCommerce- oder Shopify-Shop, um Stammdaten zu synchronisieren.',
    syncToTask: 'Mit Task synchronisieren',
    selectTask: 'Wählen Sie einen Task für die Synchronisierung',
    selectTaskDesc: 'Jeder Task wendet seine eigenen Filter an.',
    managedOnPricing: 'Shop-Anbindungen werden auf der Seite „Meine Preise" verwaltet.',
    projectLabel: 'Projekt',
    deleteConfirm: 'Diese Anbindung löschen? Synchronisierte Produkte bleiben erhalten.',
    syncSuccessWithTask: '{{count}} Produkte mit {{task}} synchronisiert',
  },

  // ============================================================================
  // Scheduled Crawls
  // ============================================================================
  scheduling: {
    // Page
    title: 'Geplante Crawls',
    subtitle: 'Automatisieren Sie Ihre Crawl-Jobs mit geplanter Ausführung.',

    // Table headers
    jobName: 'Job-Name',
    project: 'Projekt',
    schedule: 'Zeitplan',
    mode: 'Modus',
    lastRun: 'Letzter Lauf',
    nextRun: 'Nächster Lauf',

    // Status
    statusActive: 'Aktiv',
    statusPaused: 'Pausiert',
    statusFailed: 'Fehlgeschlagen',
    statusRunning: 'Läuft',

    // Filters
    filterAll: 'Alle',
    filterActive: 'Aktiv',
    filterPaused: 'Pausiert',
    filterFailed: 'Fehlgeschlagen',

    // Actions
    createSchedule: 'Zeitplan erstellen',
    editSchedule: 'Zeitplan bearbeiten',
    deleteSchedule: 'Zeitplan löschen',
    pauseSchedule: 'Pausieren',
    resumeSchedule: 'Fortsetzen',
    runNow: 'Jetzt ausführen',
    viewRuns: 'Läufe anzeigen',
    retryRun: 'Erneut versuchen',
    discardRun: 'Verwerfen',

    // Empty state
    noSchedules: 'Noch keine geplanten Crawls.',
    noSchedulesHint: 'Erstellen Sie einen, um Ihre Crawl-Jobs zu automatisieren.',

    // Delete confirmation
    confirmDelete: 'Sind Sie sicher, dass Sie diesen Zeitplan löschen möchten? Dies kann nicht rückgängig gemacht werden.',
    confirmDiscard: 'Sind Sie sicher, dass Sie diesen Lauf verwerfen möchten? Die Ergebnisse werden entfernt.',

    // Schedule display
    everyNHours: 'Alle {value} Stunden',
    everyNDays: 'Alle {value} Tage',
    everyNWeeks: 'Alle {value} Wochen',
    everyNMonths: 'Alle {value} Monate',
    cronSchedule: 'Cron: {expression}',

    // Crawl modes
    modeReextract: 'Daten neu extrahieren',
    modeReextractDesc: 'Vorhandene URLs erneut abrufen mit frischer Extraktion, Normalisierung und Matching',
    modeRecrawl: 'Neu crawlen & neue URLs finden',
    modeRecrawlDesc: 'Kompletter Crawl um neue Produktseiten zu finden, dann Extraktion, Normalisierung und Matching',
    modeRenormalize: 'Neu normalisieren + Matching',
    modeRenormalizeDesc: 'KI-Normalisierung und Matching erneut auf vorhandenen Extraktionen ausführen (kein Crawl)',
    modeRefreshPlatforms: 'Nur Plattformen aktualisieren',
    modeRefreshPlatformsDesc: 'Plattform-Preise erneut scrapen, ohne Shop-/Wettbewerberdaten zu ändern',
    modeReextractSelectors: 'Selektoren aktualisieren + neu extrahieren',
    modeReextractSelectorsDesc: 'Seiten-Selektoren neu erkennen, dann mit neuen Selektoren extrahieren',
    modeRediscover: 'Neu entdecken',
    modeRediscoverDesc: 'Neue und geänderte Seiten finden.',
    modeFullFresh: 'Komplett neu starten',
    modeFullFreshDesc: 'Selektoren neu erkennen + kompletter Neucrawl. Setzt Normalisierungshistorie zurück.',

    // Create dialog
    wizardTitle: 'Zeitplan erstellen',
    wizardEditTitle: 'Zeitplan bearbeiten',
    stepJob: 'Job',
    stepTiming: 'Timing',
    stepMode: 'Modus',
    stepPipeline: 'Pipeline',
    stepNotifications: 'Benachrichtigungen',
    stepAdvanced: 'Erweitert',

    // Pipeline step
    pipelineFlow: 'Pipeline-Ablauf',
    pipelineCrawl: 'Crawl',
    pipelineExtract: 'Extrahieren',
    pipelineNormalize: 'Normalisieren',
    pipelineMatch: 'Abgleichen',
    pipelineAiDesc: 'KI-gestützte Normalisierung liefert die besten Ergebnisse. Nutzt Claude — kostet Credits.',
    pipelineSelectorDesc: 'Selektor-basierte Normalisierung verwendet Extraktions-Selektoren. Kostenlos — keine KI-Aufrufe.',
    normalizationStrategy: 'Normalisierung',
    normModeAi: 'KI-gestützt',
    normModeAiDesc: 'Nutzt Claude zur Normalisierung der Produktdaten. Beste Qualität, benötigt Credits.',
    normModeSelector: 'Selektor-basiert',
    normModeSelectorDesc: 'Verwendet Seiten-Selektoren zur Normalisierung. Kostenlos, keine KI-Kosten. Gut für einheitliche Seitenstrukturen.',
    normCredits: 'Credits',
    normFree: 'Kostenlos',

    // Step 1: Job selection
    selectJob: 'Job auswählen',
    selectJobHint: 'Wählen Sie einen abgeschlossenen Job für wiederkehrende Crawls.',
    noJobsAvailable: 'Keine abgeschlossenen Jobs verfügbar.',

    // Step 2: Timing
    scheduleType: 'Zeitplan-Typ',
    typeInterval: 'Intervall',
    typeCron: 'Cron-Ausdruck',
    intervalValue: 'Alle',
    intervalUnit: 'Einheit',
    unitHours: 'Stunden',
    unitDays: 'Tage',
    unitWeeks: 'Wochen',
    unitMonths: 'Monate',
    cronExpression: 'Cron-Ausdruck',
    cronHelp: 'Standard 5-Feld Cron-Format (Min Std Tag Mon Wtag)',
    timezone: 'Zeitzone',
    presets: 'Schnellvorlagen',
    presetDaily: 'Täglich um 6:00 Uhr',
    presetWeekly: 'Wöchentlich am Montag',
    presetBiweekly: 'Alle 2 Wochen',
    presetMonthly: 'Monatlich am 1.',

    // Step 3: Crawl mode
    crawlMode: 'Crawl-Modus',
    autoNormalize: 'Ergebnisse automatisch normalisieren',
    autoMatch: 'Produkte automatisch abgleichen',
    autoMatchDesc: 'Nach der Normalisierung Produkte automatisch mit dem Master für den Preisvergleich abgleichen.',

    // Step 4: Notifications
    notifyOnFailure: 'Bei Fehler benachrichtigen',
    notifyOnSuccess: 'Bei Erfolg benachrichtigen',
    notifyOnPriceChange: 'Bei Preisänderungen benachrichtigen',
    priceChangeThreshold: 'Preisänderungsschwelle (%)',
    notificationEmails: 'Benachrichtigungs-E-Mails',
    addEmail: 'E-Mail hinzufügen',

    // Step 5: Advanced
    maxFailures: 'Max. aufeinanderfolgende Fehler vor Auto-Pause',
    maxFailuresHint: 'Der Zeitplan wird nach dieser Anzahl aufeinanderfolgender Fehler automatisch pausiert.',

    // Run history
    runHistory: 'Laufhistorie',
    runNumber: '#',
    runDate: 'Datum',
    runDuration: 'Dauer',
    runMode: 'Modus',
    runStatus: 'Status',
    runProducts: 'Produkte',
    runPriceChanges: 'Preisänderungen',
    totalRuns: 'Gesamt-Läufe',
    successRate: 'Erfolgsrate',
    avgDuration: 'Ø Dauer',
    lastPriceChange: 'Letzte Preisänderung',
    noRuns: 'Noch keine Läufe.',
    noRunsHint: 'Dieser Zeitplan wurde noch nicht ausgeführt.',

    // Run status
    runQueued: 'Warteschlange',
    runRunning: 'Läuft',
    runSuccess: 'Erfolgreich',
    runFailed: 'Fehlgeschlagen',
    runDiscarded: 'Verworfen',

    // Errors
    errorLoading: 'Zeitpläne konnten nicht geladen werden.',
    errorCreating: 'Zeitplan konnte nicht erstellt werden.',
    errorUpdating: 'Zeitplan konnte nicht aktualisiert werden.',
    errorDeleting: 'Zeitplan konnte nicht gelöscht werden.',
    errorPausing: 'Zeitplan konnte nicht pausiert werden.',
    errorResuming: 'Zeitplan konnte nicht fortgesetzt werden.',
    errorRunNow: 'Sofortige Ausführung konnte nicht ausgelöst werden.',
    errorRetry: 'Erneuter Versuch konnte nicht ausgelöst werden.',
    errorDiscard: 'Lauf konnte nicht verworfen werden.',

    // Success messages
    created: 'Zeitplan erfolgreich erstellt.',
    updated: 'Zeitplan erfolgreich aktualisiert.',
    deleted: 'Zeitplan erfolgreich gelöscht.',
    paused: 'Zeitplan pausiert.',
    resumed: 'Zeitplan fortgesetzt.',
    runTriggered: 'Sofortige Ausführung ausgelöst.',
    runRetried: 'Erneuter Versuch ausgelöst.',
    runDiscardedSuccess: 'Lauf verworfen.',

    // Misc
    consecutiveFailures: '{count} aufeinanderfolgende Fehler',
    nextRunIn: 'Nächster Lauf in {time}',
    lastRunAgo: 'vor {time}',
    neverRun: 'Nie',
  },

  // ============================================================================
  // Dynamic Refresh
  // ============================================================================
  refresh: {
    mode: {
      forceAll: 'Alles aktualisieren',
      forceAllDesc: 'Alle konfigurierten Entitäten unabhängig vom Zeitplan aktualisieren',
      dueOnly: 'Nur fällige',
      dueOnlyDesc: 'Nur Entitäten aktualisieren, deren Intervall abgelaufen ist',
      customSelection: 'Benutzerdefinierte Auswahl',
      customSelectionDesc: 'Bestimmte Entitäten zur Aktualisierung auswählen',
      customSelectionHint: 'Wählen Sie unten die Entitäten aus, die in diesem Aktualisierungslauf enthalten sein sollen.',
    },
    preview: {
      loading: 'Lade Vorschau...',
      title: 'Aktualisierungs-Vorschau',
      toRefresh: 'zu aktualisieren',
      skipped: 'nicht fällig',
      byType: 'Nach Typ',
    },
    policy: {
      title: 'Aktualisierungsrichtlinie',
      defaultInterval: 'Standard-Intervall',
      hours: 'Stunden',
      master: 'Master-Domain',
      competitors: 'Wettbewerber',
      platforms: 'Plattformen',
      inherited: 'Verwendet Standard',
    },
    state: {
      lastSuccess: 'Letzter Erfolg',
      lastAttempt: 'Letzter Versuch',
      consecutiveFailures: 'Aufeinanderfolgende Fehler',
      never: 'Nie',
      hoursDue: 'Fällig in {{hours}} Stunden',
      overdue: 'Überfällig um {{hours}} Stunden',
    },
  },
  refreshPicker: {
    title: 'Entitäten zum Aktualisieren auswählen',
    loading: 'Entitäten werden geladen…',
    selected: 'ausgewählt',
    selectAll: 'Alle auswählen',
    deselectAll: 'Alle abwählen',
    startRefresh: 'Aktualisierung starten',
    noEntities: 'Keine Entitäten für diese Aufgabe gefunden.',
  },

  // ============================================================================
  // Run Action Modal
  // ============================================================================
  action: {
    title: 'Aktion ausführen',
    runAction: 'Aktion ausführen',
    selectAction: 'Aktion',
    entityScope: 'Entitäten-Auswahl',
    allEntitiesIncluded: 'Alle Entitäten eingeschlossen — diese Aktion wird auf dem gesamten Datensatz ausgeführt.',

    refreshData: 'Daten aktualisieren',
    refreshDataDesc: 'Bestehende URLs erneut crawlen mit vorhandenen Selektoren, dann normalisieren und abgleichen.',
    refreshSelectors: 'Selektoren aktualisieren',
    refreshSelectorsDesc: 'KI-Selektor-Erkennung erneut ausführen, um CSS-Selektoren zu aktualisieren, ohne Daten neu zu extrahieren',
    startFresh: 'Neu starten',
    startFreshDesc: 'Komplette Pipeline von vorne — Selektoren neu entdecken, alle Seiten crawlen, normalisieren und abgleichen.',
    startFreshWarning: 'Dies wird alle Selektoren neu entdecken und alles erneut crawlen. Vorherige Daten werden ersetzt.',
    startFreshManualDesc: 'Komplette Pipeline von vorne — alle Seiten mit manuellen Selektoren crawlen, normalisieren und abgleichen.',
    startFreshManualWarning: 'Dies wird alles mit manuellen Selektoren erneut crawlen. Vorherige Daten werden ersetzt.',
    custom: 'Benutzerdefiniert',
    customDesc: 'Konfigurieren Sie, welche Pipeline-Schritte ausgeführt und welche Entitäten einbezogen werden sollen.',
    resume: 'Pipeline fortsetzen',
    resumeDesc: 'Die fehlgeschlagene Pipeline ab dem Schritt {phase} fortsetzen.',

    catalogRefreshPlatforms: 'Plattformen aktualisieren',
    catalogRefreshPlatformsDesc: 'Alle Plattformen mit aktuellen Katalogprodukten neu scrapen und Ergebnisse matchen',

    catalogFullFresh: 'Komplett neu starten',
    catalogFullFreshDesc: 'Katalog-CSV neu einlesen, virtuelle Master neu erstellen, alle Plattformen neu scrapen',
    catalogFullFreshWarning: 'Dies verwirft alle bestehenden Daten und startet von vorne.',

    refreshResults: 'Ergebnisse aktualisieren',
    refreshResultsDesc: 'Gleiche URLs vom letzten Lauf erneut crawlen für aktualisierte Inhalte',
    recrawlDiscover: 'Neu crawlen & entdecken',
    recrawlDiscoverDesc: 'Neuer Crawl von Task-URLs um neue Seiten zu finden',

    modulesRecrawl: 'Neu crawlen',
    modulesRecrawlDesc: 'Alle konfigurierten URLs neu crawlen um neue Seiten zu finden',
    modulesFullFresh: 'Komplett neu starten',
    modulesFullFreshDesc: 'Vollständiger Neu-Crawl von Grund auf',
    modulesFullFreshWarning: 'Dies verwirft alle bestehenden Daten und startet von vorne.',

    modeCatalog: 'Katalog',
    modeDiscovery: 'Discovery',
    modeModules: 'Module',
    modeManual: 'Manuell',

    // UI strings
    loadingEntities: 'Entitäten werden geladen…',
    selected: 'ausgewählt',
    groupMaster: 'Master',
    groupCompetitors: 'Wettbewerber',
    groupPlatforms: 'Plattformen',
    running: 'Wird ausgeführt…',
    run: 'Ausführen',
  },

  // Pipeline Phase Labels
  // ============================================================================
  pipeline: {
    discovering: 'Selektoren ermitteln',
    crawling: 'Crawling',
    extracting: 'Extraktion',
    normalizing: 'Normalisierung',
    preFiltering: 'Vorfilterung',
    normalizingCompetitors: 'Wettbewerber normalisieren',
    matching: 'Matching',
    platformScraping: 'Plattform-Scraping',
    fieldMapping: 'Feld-Zuordnung',
    running: 'Wird ausgeführt',
    failed: 'Fehlgeschlagen',
    cancelled: 'Abgebrochen',
    complete: 'Abgeschlossen',
    ready: 'Bereit',
    extracted: 'Extrahiert',
    readyToRun: 'Pipeline kann gestartet werden',
    inProgress: 'Pipeline läuft',
  },

  // Pipeline Step Toggles (Custom Run)
  // ============================================================================
  pipelineSteps: {
    title: 'Pipeline-Schritte',
    crawl: 'Crawl (URLs entdecken)',
    extract: 'Extraktion (Selektoren anwenden)',
    normalize: 'Normalisierung / Feld-Zuordnung',
    matching: 'Produkte matchen',
    platforms: 'Plattform-Scraping',
    freshUrls: 'Neue URLs verwenden',
    freshUrlsDesc: 'URLs neu entdecken statt vorhandene wiederzuverwenden',
    skipCrawl: 'Keine vorhandenen Crawl-Daten — Crawl-Schritt erforderlich',
    skipExtract: 'Keine vorhandenen Extraktionsdaten — Extraktionsschritt erforderlich',
    skipNormalize: 'Normalisierung überspringen',
    skipMatching: 'Matching überspringen',
    skipPlatforms: 'Plattform-Scraping überspringen',
  },

  // Execution Mode Step (Job Creation Wizard Step 3)
  // ============================================================================
  executionMode: {
    title: 'Ausführungsmodus',
    description: 'Wählen Sie, wie die Pipeline nach der Job-Erstellung ausgeführt werden soll.',
    automatic: 'Automatischer Modus',
    recommended: 'Empfohlen',
    automaticDesc: 'Die gesamte Pipeline wird nach der Job-Erstellung automatisch ausgeführt — AI-Selektoren, Normalisierung, Matching und Plattform-Scraping.',
    manual: 'Manueller Modus',
    advanced: 'Erweitert',
    manualDesc: 'Sie steuern, welche Pipeline-Schritte ausgeführt werden. Starten Sie jeden Schritt manuell über das Job-Dashboard.',
    pipelineSteps: 'Pipeline-Schritte',
    aiSelectorDiscovery: 'AI-Selektor-Erkennung',
    aiSelectorsSkippedHint: 'Übersprungen — Sie müssen Domain-Selektoren manuell konfigurieren, bevor Sie extrahieren.',
    aiSelectorsEnabledHint: 'AI analysiert Seiten und erkennt CSS-Selektoren automatisch.',
    normalization: 'Normalisierung',
    normalizationHint: 'Extrahierte Produktdaten mithilfe von AI standardisieren und bereinigen.',
    matching: 'Matching',
    matchingHint: 'Master-Produkte mit Wettbewerber-Produkten für den Vergleich abgleichen.',
  },


};
